/*! @hebcal/core v5.9.8, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */
import { Locale } from '@hebcal/hdate';
export { Locale } from '@hebcal/hdate';
import poAshkenazi from './ashkenazi.po.js';
import poHe from './he.po.js';
import noNikudOverride from './he-x-NoNikud.po.js';

Locale.addTranslations('he', poHe);
Locale.addTranslations('h', poHe);
Locale.addTranslations('ashkenazi', poAshkenazi);
Locale.addTranslations('a', poAshkenazi);
/* Hebrew without nikkud */
const heStrs = poHe.contexts[''];
const heNoNikud = {};
for (const [key, val] of Object.entries(heStrs)) {
    heNoNikud[key] = [Locale.hebrewStripNikkud(val[0])];
}
const poHeNoNikud = {
    headers: poHe.headers,
    contexts: { '': heNoNikud },
};
Locale.addTranslations('he-x-NoNikud', poHeNoNikud);
Locale.addTranslations('he-x-NoNikud', noNikudOverride);
//# sourceMappingURL=locale.js.map
